export default __webpack_public_path__ + "static/media/ac_als.d94cf6d5.bmp";